import uuid from 'utils/uuid';
import { formatDate, parseDate } from 'utils/format';
import { apiClientGetRequest } from '../lib/backendRequest';

const eventsApi = accessToken => ({
  /**
   *
   * @param {string} countryCode
   * @param {string} initialMonth
   * @param {number} numberOfMonths
   * @returns
   */
  getHolidayEvents: async (countryCode, initialMonth, numberOfMonths = 12) => {
    try {
      const startDate = parseDate(initialMonth, 'YYYY-MM');
      const endDate = parseDate(initialMonth, 'YYYY-MM');
      endDate.setMonth(startDate.getMonth() + numberOfMonths);
      endDate.setHours(startDate.getHours() - 1);

      let year = startDate.getFullYear();
      const years = [year];
      while (year < endDate.getFullYear()) {
        year += 1;
        years.push(year);
      }

      const events = [];
      const eventType = {};

      for (let i = 0; i < years.length; i += 1) {
        const response = await apiClientGetRequest(
          `api/v1/events/public/${countryCode}/${years[i]}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Token ${accessToken}`,
            },
          },
        );

        const json = await response.json();

        json.data.forEach(item => {
          const date = parseDate(item.date, 'MM/DD/YYYY');

          if (date >= startDate && date <= endDate) {
            events.push({
              key: uuid(),
              description: item.name,
              date: formatDate(date, 'YYYY-MM-DD'),
              type: item.type,
            });
            eventType[item.type] = true;
          }
        });
      }

      return {
        data: {
          events,
          types: Object.keys(eventType).sort(),
        },
      };
    } catch (error) {
      return { error };
    }
  },

  getClassicEvents: async () => {
    try {
      const response = await apiClientGetRequest('api/v1/ancestry/classic/calendar/history', {
        method: 'GET',
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });

      const json = await response.json();

      return {
        data: {
          events: json.data,
          years: Object.keys(json.data).sort().reverse(),
        },
      };
    } catch (error) {
      return { error };
    }
  },
});

export default eventsApi;
